// extracted by mini-css-extract-plugin
export default {"documentPreview":"styles_documentPreview__AF96S"};